import config from './../config'
import $ from 'jquery'
import Vue from 'vue'

Vue.directive('signup', {
  inserted: function (el) {
    if ($(el).is('a')) {
      $(el).attr('href', config.signupUrl)
    } else {
      $(el).bind('click', () => {
          window.open(config.signupUrl, '_self')
        }
      )
    }
  }
})

Vue.directive('signin', {
  inserted: function (el) {
    if ($(el).is('a')) {
      $(el).attr('href', config.signinUrl)
    } else {
      $(el).bind('click', () => {
          window.open(config.signinUrl, '_self')
        }
      )
    }
  }
})

Vue.directive('try', (el, binding) => {
  let path = ''
  if (binding.value !== '/') {
    path = binding.value.toLowerCase()
  }
  let url = config.appUrl + '/' + path
  if ($(el).is('a')) {
    $(el).attr('href', url)
  } else {
    $(el).bind('click', () => {
        window.open(url, '_self')
      }
    )
  }
})



// WEBPACK FOOTER //
// ./client/directives/signup.js